export default "__VITE_ASSET__BQIT4uv8__"